import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { ProductVariantModel } from './product-variant.model';

@Injectable({
  providedIn: 'root',
})
export class ProductVariantService extends AbstractEntityService<ProductVariantModel> {
  constructor(http: HttpClient) {
    super('/api/product-variants', http);
  }
}
